"use client";

import {
    Dialog,
    DialogContent,
    DialogDescription,
    DialogFooter,
    DialogHeader,
    DialogTitle,
} from "@/components/ui/dialog";
import * as React from "react";

interface ConfirmDialogProps {
    open: boolean;
    onOpenChange: ( open: boolean ) => void;
    title: string;
    description: string;
    icon?: React.ReactNode;
    confirmText?: string;
    cancelText?: string;
    onConfirm: () => void;
    isLoading?: boolean;
    enableBackInterceptor?: boolean;
}

export function ConfirmDialog(
    {
        open,
        onOpenChange,
        title,
        description,
        confirmText = "Confirm",
        cancelText = "Never mind",
        onConfirm,
        isLoading = false,
        enableBackInterceptor = true,
    }: ConfirmDialogProps,
) {
    const handleCancel = () => {
        onOpenChange( false );
    };

    const handleConfirm = () => {
        onConfirm();
    };

    return (
        <Dialog open={open} onOpenChange={onOpenChange} enableBackInterceptor={enableBackInterceptor}>
            <DialogContent className="max-w-xs p-0 overflow-hidden rounded-xl [&_*[data-slot=dialog-close]]:hidden gap-0">
                <DialogHeader className="p-4 text-center">
                    <DialogTitle className="text-base font-semibold text-t1">{title}</DialogTitle>
                    <DialogDescription className="text-base text-t3 mt-2">{description}</DialogDescription>
                </DialogHeader>

                <DialogFooter className="flex-row gap-0 px-0 pb-0 pt-0 border-t border-stroke">
                    <button
                        type="button"
                        onClick={handleCancel}
                        disabled={isLoading}
                        className="flex-1 h-12 text-base font-medium text-t3 bg-surface-card transition-colors disabled:opacity-50 disabled:cursor-not-allowed border-r border-stroke"
                    >
                        {cancelText}
                    </button>
                    <button
                        type="button"
                        onClick={handleConfirm}
                        disabled={isLoading}
                        className="flex-1 h-12 text-no font-semibold bg-surface-card transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
                    >
                        {isLoading && (
                            <div className="w-4 h-4 border-2 border-state-danger border-t-transparent rounded-full animate-spin" />
                        )}
                        {confirmText}
                    </button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}
